<template>

  <div class="range">
    <p class="xq">
      <span class="xq_1">离你最近的校区</span>
      <a v-for="area in areaCityPoint" v-bind:href="areaCityPointURL(schoolID,area.Code)" class="range_xq">{{area.Name}}</a>
      <!--	<a href="#" class="range_xq">北大街教学区</a>
        <a href="#" class="range_xq">北大街教学区</a>-->
    </p>
  </div>
</template>
<script>
    export default{
        props: ['areaCityPoint','schoolID'],
        data: function () {
            return {

            }
        },
        methods: {
          areaCityPointURL: function (schoolID, code) {
            return `http://souke.xdf.cn/Campus/${schoolID}-${code}.html`
          }

        },
      computed:{

      },
      mounted(){

      }
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// components/NearCampus.vue